import { useParams } from '@tanstack/react-router'
import { CantileverLinkButton } from 'components/CantileverButton'
import { AddLinkModal } from 'features/processFlowDiagrams/components/AddLinkModal'
import { ExternalLink } from 'lucide-react'
import React, { useState } from 'react'
import styled from 'styled-components'
import { PfdNode } from 'types'

const NodeContainer = styled.div`
  position: relative;
  display: inline-block;
`

const FloatingLinkButtonContainer = styled.div`
  position: absolute;
  top: -2rem;
  right: -1rem;
  z-index: 10;
`

export const sharedButtonStyles = `
  width: 2rem;
  height: 0.5rem;
  border-radius: 50%;
  transition: all 0.2s ease;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);

  &:hover {
    opacity: 1;
    transform: scale(1.1);
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 0.875rem;
    height: 0.875rem;
  }
`

const StyledCantileverLinkButton = styled(CantileverLinkButton)`
  ${sharedButtonStyles}
`

export const BaseNodeWrapper = ({
  children,
  link,
  id,
  setNodes,
}: {
  children: React.ReactNode
  id: string
  link?: {
    entryType: string
    entryID: string
    siteID: string
  }
  setNodes: (payload: PfdNode[] | ((nodes: PfdNode[]) => PfdNode[])) => void
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { siteID } = useParams({ strict: false })

  const handleLinkChange = (newLink: {
    entryType: string
    entryID: string
    siteID: string
  }) => {
    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? { ...node, data: { ...node.data, link: newLink } }
          : node
      )
    )
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  return (
    <NodeContainer>
      {children}
      {link && (
        <FloatingLinkButtonContainer>
          <StyledCantileverLinkButton
            to={`/assets/${link.siteID}/${link.entryID}`}
            primary
            iconOnly
            title='Open link'
            aria-label='Open link'>
            <ExternalLink />
          </StyledCantileverLinkButton>
        </FloatingLinkButtonContainer>
      )}
      {siteID && (
        <AddLinkModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          onSave={handleLinkChange}
          siteID={siteID}
        />
      )}
    </NodeContainer>
  )
}
